import { Box, Tab, Tabs } from '@mui/material';

import type { IngestDataTabsProps } from './IngestDataTabs.types';

/**
 * IngestDataTabs renders a tabbed interface for container-based ingest configuration.
 * Tabs: "Ingest Method Config" and "Data Provider" with error indicators.
 * Only shown for sources that support container ingestion (e.g., Microsoft).
 */
const IngestDataTabs = ({
  selectedTab,
  onTabChange,
  hasIngestMethodErrors,
  hasDataProviderError,
  className
}: IngestDataTabsProps) => {
  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    onTabChange(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        className={className}
        value={selectedTab}
        onChange={handleTabChange}
        aria-label="wrapped label tabs example"
        scrollButtons="auto"
        variant="scrollable"
      >
        <Tab
          className={hasIngestMethodErrors ? 'errorTabText' : ''}
          value="ingest_method_config"
          label="Ingest Method Config"
        />
        <Tab
          className={hasDataProviderError ? 'errorTabText' : ''}
          value="data_provider"
          label="Data Provider"
        />
      </Tabs>
    </Box>
  );
};

export default IngestDataTabs;
